import "../utils/calendar.mjs";
import { css as e, styled as t } from "styled-components";
//#region src/components/DatePicker/styled/Popups.styled.ts
var n = e`
    position: absolute;
    ${({ $placement: e }) => e === "top" ? "bottom: calc(100% + 6px); top: auto;" : "top: calc(100% + 6px);"}
    left: 0;
    z-index: 200;
    background: ${({ theme: e }) => e.colors.card};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
    box-shadow: ${({ theme: e }) => e.shadows.lg};
    padding: ${({ theme: e }) => e.spacing(2)};
    animation: calIn 0.12s ease;
    @keyframes calIn {
        from {
            opacity: 0;
            transform: translateY(${({ $placement: e }) => e === "top" ? "4px" : "-4px"});
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`, r = t.div`
    ${n}
    width: ${312}px;
`, i = t.div`
    ${n}
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0;
    overflow: hidden;
`, a = t.div`
    display: flex;
    align-items: flex-start;
    gap: ${({ theme: e }) => e.spacing(2)};
    padding: ${({ theme: e }) => e.spacing(2)};
`, o = t.div`
    width: 1px;
    align-self: stretch;
    background: ${({ theme: e }) => e.colors.border};
    flex-shrink: 0;
`, s = t.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme: e }) => e.spacing(1)};
    padding: ${({ theme: e }) => e.spacing(1.5, 2)};
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
    flex-shrink: 0;
`, c = t.div`
    padding: ${({ theme: e }) => e.spacing(2)};
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(3)};
`, l = t.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: ${({ theme: e }) => e.spacing(1.5)};
    margin-top: ${({ theme: e }) => e.spacing(1)};
    background: none;
    border: 1.5px dashed ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.md};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    cursor: pointer;
    transition:
        color ${({ theme: e }) => e.transitions.fast},
        border-color ${({ theme: e }) => e.transitions.fast};

    &:hover {
        color: ${({ theme: e }) => e.colors.foreground};
        border-color: ${({ theme: e }) => e.colors.primary};
    }
`, u = t.div`
    width: ${312}px;
`, d = t.div`
    display: flex;
    align-items: flex-start;
    gap: ${({ theme: e }) => e.spacing(2)};
    ${({ $fluid: e }) => e && "\n        width: 100%;\n\n        & > *:not(hr) {\n            flex: 1;\n            min-width: 0;\n        }\n    "}
`;
//#endregion
export { o as Divider, i as DualPopup, d as InlineDual, u as InlineSingle, l as LoadMoreBtn, c as MobileCalendarContent, a as PopupCalendarsRow, s as PopupFooter, r as SinglePopup };
